<h4 mat-dialog-title><i class="fas fa-edit mr-1"></i> Update License Expiry</h4>

<mat-dialog-content class="mat-typography">
    <div>
        <form class="example-form input-content" [formGroup]="form">
            <mat-form-field class="example-full-width" *ngIf="false">
                <mat-label>Organization*</mat-label>
                <input matInput formControlName="organizationId" disabled>
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Expiry Date*</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="expiryDate" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions style="display: flex; justify-content: center;">
    <button class="btn btn-success mr-2" type="submit" [disabled]="!form.valid" (click)="updateLicenseExpiryData()">
        <i class="fas fa-save mr-1"></i> Save
    </button>
    <button class="btn btn-light" aria-label="cancel" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel
    </button>
</mat-dialog-actions>